import { Injectable } from '@angular/core';
import { OrderLocal, OrderUser, Item} from 'src/app/shared/Interfaces/pedido';
import { ApiService } from '../API/api.service';
import { Router } from '@angular/router';
import { CacheService } from '../Cache/cache.service';
import { Company, ConnectionService } from '../Connection/connection.service';
import { Location } from '@angular/common';
import { BehaviorSubject, Observable } from 'rxjs';
import { CartService } from '../Cart/cart.service';
import { placeCounter, typeInterface } from 'src/app/shared/Interfaces/company';
import { Cliente } from 'src/app/shared/Interfaces/customer';
import { PixelService } from '../pixel.service';
import { PedidoObject } from '../../models/pedido.class';
import { NotificationService } from '../notification.service';
import * as _ from 'lodash';



@Injectable({
  providedIn: 'root'
})
export class OrderService {

  private nameCompany: string = '';
  private typeParam!: typeInterface;
  private sacola!: OrderLocal;
  private company!: Company;
  private user!: Cliente;

  table: number = 0;
  bag: Item[] = [];
  pedidoAtual: PedidoObject = new PedidoObject();
  intervalOrder: any;

  placeEmpty: placeCounter = {
    id_place: '',
    placeName: ''
  }

  get currentPlace(): placeCounter {
    return this.placeCounterSubject.value;
  }

  counterOrderSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public counterOrder$: Observable<number> = this.counterOrderSubject.asObservable();

  idOrderSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public idOrder$: Observable<string> = this.idOrderSubject.asObservable();

  closeCardSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public closeCard$: Observable<boolean> = this.closeCardSubject.asObservable();

  responseOrderSubject: BehaviorSubject<any> = new BehaviorSubject<any>({sucess: false, error: false, local: false});
  public responseOrder$: Observable<any> = this.responseOrderSubject.asObservable();

  //PLACE | Id e nome do lugar no modo balcão
  private placeCounterSubject: BehaviorSubject<placeCounter> = new BehaviorSubject<placeCounter>(this.placeEmpty);
  public placeCounter$: Observable<placeCounter> = this.placeCounterSubject.asObservable();

  constructor(
    private location: Location,
    private cartService: CartService,
    private apiService: ApiService,
    private router: Router,
    private cacheService: CacheService,
    private connection: ConnectionService,
    private notify: NotificationService,
    private pixelService: PixelService
  )
  {

    //Nome da empresa
    this.connection.nameCompany$.subscribe((newNameCompany) => {
      this.nameCompany = newNameCompany
    });

    //Tipo do parametro
    this.connection.typeParam$.subscribe((newTypeParam) => {
      this.typeParam = newTypeParam
    });

    //Usuário
    this.connection.user$.subscribe((newUser) => {
      if(newUser){
        this.user = newUser
      }
    });
 
    //Empresa
    this.connection.company$.subscribe((newCompany) =>{
      if(newCompany){
        this.company = newCompany

        //Caso a configuração da empresa tenha Cashback
        if(this.company.configs.cashback != this.pedidoAtual.cashback){
          this.pedidoAtual.cashback = this.company.configs.cashback
        }
      }
    });

  }

  //Atualiza o local do pedido
  public updatePlace(newPlace: placeCounter){
    this.pedidoAtual.placeName = newPlace.placeName;
    console.log('Localização atualizada no pedido:', this.pedidoAtual.placeName)
    this.placeCounterSubject.next(newPlace);
  }

  //Resgata os itens do pedido
  keepBag(bag: Item[]){
    this.bag = bag;
  }

  //edita o item do pedido
  editItemBag(item: Item, index: number){
    this.bag[index] = item
  }

  //calcula o total do pedido
  private calcTotalOrder(){
    let total = 0
    this.bag.forEach(product => {
      total += product.totalPrice
    });
    return total
  }

  //Calcula o cashback
  calcCashback(): number{
    let cashback: number = 0;
    let total: number = 0
    this.bag.forEach(item => {
      total += item.totalPrice
      console.log(item);
      
      if(item.cashbackValue){
        cashback += item.cashbackValue
      }
    });

    cashback = Number(cashback.toFixed(2));

    return cashback
  }

  //Reseta o objeto do pedido
  resetOrder(){
    this.pedidoAtual = new PedidoObject();
  }

  //#region Cupons

    //Calcula quanto de desconto o produto recebera caso cupom de desconto de produto sejá aplicado
    calculateDiscount(matchingItem: any, coupon: any): number {

      //Caso o cupom seja por porcentagem
      if (coupon.percent != 0) {
        if(matchingItem.quantity > 1){
          const totalPrice = matchingItem.totalPrice / matchingItem.quantity
          let discount = totalPrice * (coupon.percent / 100);

          //Caso o desconto sejá em 100% do valor ele arredonda para 0.01
          if(discount == totalPrice){
            discount = totalPrice - 0.01;
          }

          return discount
        }
        else{
          let discount = matchingItem.totalPrice * (coupon.percent / 100);

          //Caso o desconto sejá em 100% do valor ele arredonda para 0.01
          if(discount == matchingItem.totalPrice){
            discount = matchingItem.totalPrice - 0.01;
          }

          return discount
        }

      //Caso o cupom seja por valor
      } else if (coupon.value != 0) {

        if(matchingItem.quantity > 1){
          const totalPrice = matchingItem.totalPrice / matchingItem.quantity

          if(coupon.value > totalPrice){
            return totalPrice - 0.01;
          }
        }

        //Caso o valor do cupom seja maior que o valor do produto ele arredonda para o valor do produto - 0.01
        if(coupon.value >= matchingItem.totalPrice){
          return matchingItem.totalPrice - 0.01;
        }

        return coupon.value;
      }
      return 0;
    }

  //#endregion

  //#region Comparação de produtos/Itens

    //Junta as Duplicações que foram salvas
    joinDuplications(products: Item[]){
      for (let i = 0; i < products.length; i++) {
        const product = products[i];
        const duplicates = products.filter((prod, index) => prod.id_product === product.id_product && index > i);
    
        duplicates.forEach(duplicate => {
          if (this.equalsObjectsCompare(product, duplicate, ["id_product", "observations", "discount"])) {
            console.log('Objetos iguais:', [product, duplicate]);
    
            // Atualiza a quantidade e o preço total
            product.quantity += duplicate.quantity;
            product.totalPrice = product.unitPrice * product.quantity;
    
            // Remove o item duplicado
            const indexToRemove = products.indexOf(duplicate);
            if (indexToRemove > -1) {
              products.splice(indexToRemove, 1);
            }
          }
        });
      }
    }

    // Comparando APENAS as propriedades específicas dos produtos / categorias / adicionais
    equalsObjectsCompare(obj1: any, obj2: any, keysToCompare: any): boolean {
      if (!obj1 || !obj2) return false;
    
      // Comparando APENAS as propriedades específicas dos Produtos
      if (!_.isEqual(_.pick(obj1, keysToCompare), _.pick(obj2, keysToCompare))) {
        return false;
      }
    
      // Comparando categorias
      const categories1 = obj1.categories?.map((categorie: any) => this.extractCategoryData(categorie)) || [];
      const categories2 = obj2.categories?.map((categorie: any) => this.extractCategoryData(categorie)) || [];
    
      return _.isEqual(categories1, categories2);
    }
    
    //Extrai a comparação dos adicionais e monta o objeto de comparação da categoria
    extractCategoryData(category: any): object {
      return {
        id_category: category.id_category,
        additional: category.additional?.map((additional: any) => this.extractAdditionalData(additional)) || []
      };
    }
    
    //Compara APENAS as propriedades específicas dos Adicionais
    extractAdditionalData(additional: any): object {
      return _.pick(additional, ["add_id_product", "quantitySub"]);
    }

  //#endregion

  //#region Delivery e balcão

    //Pedido efeturado Delivery ou Balcão
    OrderUser(bag: OrderUser){
      this.apiService.FazerPedido(bag).subscribe(
        (response) => {
          console.log('Pedido de usuário Feito com sucesso');

          //Atualiza a fidelidade
          this.connection.getFidelity(this.user.id_customer, this.company.company.id_company);

          //Atualiza o usuário
          this.connection.getUser(this.company.company.id_company);

          //Envia pixel
          this.pixelService.sendEvent(response.response.info[0].orders[0]);

          //Reseta carrinho e pedido
          this.resetOrder();
          
          this.cartService.clearCart();

          const order = response.response.info[0].orders[0]

          //Após 8 segundo confirma o pedido.
          setTimeout(() => {
            this.responseOrderSubject.next({sucess: true, error: false, local: false, order: order});
          }, 8000);
        },
        (error) => {
          console.log(error);
          //Após 8 segundos volta para o inicio do cardápio
          setTimeout(() => {
            if(this.typeParam.type == 3){
              this.location.replaceState(`${this.nameCompany}/B`);
              this.router.navigate([`${this.nameCompany}/B`]);
            }
            else{
              this.location.replaceState(`${this.nameCompany}`);
              this.router.navigate([this.nameCompany]);
            }
            this.notify.error('Não foi possível concluir seu pedido.');
          }, 8000);

        }
      )
    }

    //Pedido efetuado Delivery ou Balcão mas com pagamento Online, seja pix ou Cartão
    OrderUserPaymentOnline(bag: OrderUser):Observable<any>{
      return new Observable(observer => {
        this.apiService.FazerPedido(bag).subscribe(
          (response) => {

            console.log('Pedido de usuario Feito com sucesso:', response);
            observer.next(response.response.info[0].orders[0]);
            observer.complete();

            //Envia pixel
            this.pixelService.sendEvent(response.response.info[0].orders[0]);

          },
          (error) => {

            console.log('Erro ao fazer pedido',error);
            observer.error(error);
          }
        )
      });
    }

    //Finaliza o pedido feito por usuários tanto Delivery quanto Balcão
    finishedOrderUser(type: boolean){
      if(type == true){
        this.notify.success('Pedido Feito com sucesso.')
      }
      else{
        this.notify.error('Não foi possível concluir seu pedido.')
      }

      setTimeout(() => {
        this.location.replaceState(this.nameCompany);
        this.router.navigate([this.nameCompany, 'pedidos']);
      }, 1000)

      setTimeout(() => {
        this.responseOrderSubject.next({sucess: false, error: false, local: false}) 
      }, 2000);

    }

  //#endregion

  //#region Local - Mesa/Comanda

    //Monta o objeto do pedido local.
    AssembleLocalOrder(nameCustomer: string, tableNumber: number, permissionRequest: boolean, typeOrder: number){
      //Verifica se a mesa/comanda não esta em conta
      if(permissionRequest)
      {
        //Mesa
        if(typeOrder == 1)
        {
          this.cartService.idTableCardSubject.next(tableNumber.toString())
          this.cacheService.setItemLocal('number_local', tableNumber);

          this.sacola = {
            id_order: 0,
            customerName: nameCustomer,
            id_table: this.typeParam.qrCodeNumber,
            id_companyFK: this.company.company.id_company,
            displayId: '1234',
            products: this.bag,
            orderType: 1,
            cardNumber: 0,
            tableNumber: Number(this.typeParam.numberParam),
            orderPrice: this.calcTotalOrder(),
            orderStatus: '1',
          }

        }
        //Comanda
        else if(typeOrder == 2)
        {
          if(this.company.configs.cardConfig == 1){
            this.cartService.idTableCardSubject.next(tableNumber.toString())
            this.cacheService.setItemLocal('number_local', tableNumber);
          }

          this.sacola = {
            id_order: 0,
            customerName: nameCustomer,
            id_table: this.typeParam.qrCodeNumber,
            id_companyFK: this.company.company.id_company,
            displayId: '1234',
            orderType: 1,
            products: this.bag,
            cardNumber: Number(this.typeParam.numberParam),
            tableNumber: tableNumber,
            orderPrice: this.calcTotalOrder(),
            orderStatus: '1',
          }
          
        }

        this.OrderTableCard(this.sacola).subscribe(
          (data) =>{
            this.router.navigate([this.nameCompany, 'processing', 2]);

            if(this.company.configs.integration == 1){
              const order = data;
              const ids_itens = order.items.map((item: any) => item.id_item);
              this.startVerifiIntegration(ids_itens);
            }
            else{
               setTimeout(() => {
                this.responseOrderSubject.next({sucess: true, error: false, local: true});
              }, 5000);
            }
          },
          (error) =>{
            console.error('Falha ao fazer pedido:', error);
            this.notify.error('Não foi possível concluir seu pedido.');
            this.location.replaceState(`${this.nameCompany}/P`);
            this.router.navigate([`${this.nameCompany}/P`]);
          }
        );
      }
      else{
        this.notify.error('Não é possivel fazer pedido, aguarde o garçom.')
      }

    }

    //Pedido efetuado Localmente.
    OrderTableCard(bag: OrderLocal):Observable<any>{
      return new Observable(observer => {
        this.apiService.MakeOrderLocal(bag).subscribe(
          (response) => {

            this.cartService.clearCart()
            this.cacheService.removeItemLocal("product-cart");

            this.cacheService.setItemLocal('session_id', response.response.info[0].orders[0].id_order);

            observer.next(response.response.info[0].orders[0]);
            observer.complete();

          },
          (error) => {
            observer.error(error);
          }
        )
      })

    }

    //Inicia a verificação Se o pedido foi integrado.
    private startVerifiIntegration(ids: string[]){
      console.log('Started...');
      this.intervalOrder = setInterval(() => {
        this.apiService.getIntegration(ids, this.company.company.id_company).subscribe(
          (data) =>{
            console.log(data);
            if(data.integrated){
              clearInterval(this.intervalOrder);
              this.responseOrderSubject.next({sucess: true, error: false, local: true});
            }
            else if(data.expired){
              clearInterval(this.intervalOrder);
              this.responseOrderSubject.next({sucess: false, error: true, local: true});
            }
          },
          (error) =>{
            console.log(error);
          }
        )
      }, 3000);
    }

    //Finaliza todo o pedido feito de forma local. Mesa/Comanda
    finishedOrderLocal(type: boolean){
      if(type == true){

        this.notify.success('Pedido Feito com sucesso.');

        setTimeout(() => {
          this.router.navigate([`${this.nameCompany}/P`]);
        }, 1000);

        setTimeout(() => {
          this.responseOrderSubject.next({sucess: false, error: false, local: false}) 
        }, 2000);
        
      }
      else{
        this.notify.error('Sem conexão com o estabelecimento.')
      }

    }

  //#endregion

}
